// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader {
  width: 48px;
  height: 48px;
  border: 5px solid #fff;
  border-bottom-color: #E621D3;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sCAAA;AADF;;AAIA;EACE;IACE,uBAAA;EADF;EAGA;IACE,yBAAA;EADF;AACF","sourcesContent":["@import '~@assets/styles/colorsVariables.scss';\r\n\r\n.Loader {\r\n  width: 48px;\r\n  height: 48px;\r\n  border: 5px solid #fff;\r\n  border-bottom-color: #E621D3;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  box-sizing: border-box;\r\n  animation: rotation 1s linear infinite;\r\n}\r\n\r\n@keyframes rotation {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Loader": `Loader`,
	"rotation": `rotation`
};
export default ___CSS_LOADER_EXPORT___;
